const backgroundRemover = {
  backgroundRemoverTitle: 'HitPaw Online AI Background Remover',
  NoWatermark: 'No watermark',
  UnlimitedHDExport: 'Unlimited HD exports',
  NoFileSizeLimit: 'No file size limit',
  BatchProcessing: 'Batch processing',
  UseAllTemplates: 'All templates, backgrounds, elements, text are available',
  CancelAtAnytime: 'Cancel subscription anytime',
  HighPriorityUnlimited: 'Unlimited high priority processing',
  YearDayPrice: '$0.13',
  YearTotalPrice: '$46.99',
  MonthDayPrice: '$0.26',
  MonthTotalPrice: '$7.99',
  WeekDayPrice: '$0.57',
  WeekTotalPrice: '$3.99',
  Day: 'Day',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Yearly: 'Yearly',
};

export default backgroundRemover;
